import React from 'react';
import SpaceSettingLockForm from './SpaceSettingLockForm';

var SpaceSettingLock = class extends React.Component {render()

  {
    const { updateCurrentSpace, setting = {} } = this.props;

    return (
      <div className="nav-section-content-container" style={{ padding: 0 }}>
        <header className="nav-header">
          <div className="nav-section-header-title">
            <span>门禁设置</span>
          </div>
        </header>
        <div className="kb-form-container">
          <fieldset className="fieldset">
            <SpaceSettingLockForm
            setting={setting}
            updateCurrentSpace={updateCurrentSpace} />

          </fieldset>
        </div>
      </div>);

  }};


export default SpaceSettingLock;
